/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import { getSnapshot } from 'mobx-state-tree';
/**
 * a set of APIs for card operations
 * @module CardAPI
 */
export default class CardAPI {
	constructor(cardModel) {

		/**
		 * To be invoked by the product only.
		 */
		this.destroy = function() {
			cardModel = null;
		};

		/**
		 * @return {string} id of this card
		 */
		this.getId = function() {
			return cardModel.id;
		};

		/**
		 * @return {string} type of this card
		 */
		this.getType = function() {
			return cardModel.type;
		};

		/**
		 * @return {boolean} whether this card is 'hidden'
		 */
		this.isHidden = function() {
			return cardModel.isHidden;
		};

		/**
		 * @return {LiveWidget[]} LiveWidget APIs of the widgets in this card
		 */
		this.getWidgetIds = function() {
			return cardModel.getWidgets().map(
				widget => widget.getId()
			);
		};


		/**
		 * @return {} feature API
		 */
		this.getFeature = function(featureName) {
			return cardModel.getFeature(featureName);
		};


		/**
		 * @param {string} id - id of the widget
		 * @return {LiveWidget[]} LiveWidget APIs of the widgets in this card
		 */
		this.getExploreWidgetApi = function(id) {
			const widget = (cardModel.items || []).find((widget) => widget.id === id);
			return widget ? widget.getAPI() : undefined;
		};

		/**
		 * @return {object} Snapshot of the state
		 */
		this.getState = function() {
			return getSnapshot(cardModel);
		};
	}
}



// WEBPACK FOOTER //
// ./src/js/api/CardAPI.js